import React from 'react';
import Create from '../../../create';

export default function BookParcel() {
  const schema = [
    {
      tabName: 'Company Details',
      editFields: [
        {
          label: 'Company Name',
          name: 'name',
          type: 'text',
        },
        {
          label: 'Phone Number',
          name: 'username',
          type: 'text',
        },
        {
          label: 'Email',
          name: 'email',
          type: 'text',
        },
        {
          label: 'Password',
          name: 'password',
          type: 'text',
        },
      ],
    },
  ];
  return (
    <Create
      return="/dashboard/companies"
      url={`${process.env.REACT_APP_API_SERVER}/companies`}
      dataID={null}
      schema={schema}
    />
  );
}
